import { render, staticRenderFns } from "./ownMetope.vue?vue&type=template&id=089bcdf1&scoped=true&"
import script from "./ownMetope.vue?vue&type=script&lang=js&"
export * from "./ownMetope.vue?vue&type=script&lang=js&"
import style0 from "./ownMetope.vue?vue&type=style&index=0&id=089bcdf1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089bcdf1",
  null
  
)

export default component.exports